import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import CPUForm from './CPUForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/cpuActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const CPUEdit = props => {
    const { cpus, loading, classes, onFetchCPUInit, activeCustomer, translations, permissions } = props;
    const [data, setData] = useState(true);
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ComponentID'] = cpus.ComponentID;
        data['ComponentType'] = 'cpu';
        data['ProductID'] = searchParams.productID;

        let result = await props.onEditCPU({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchCPU({ ActiveCustomerID: activeCustomer, ComponentID: parseURL(window.location.href).ComponentID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchCPUInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ComponentType: "cpu",
        Vendor: cpus.Vendor || "",
        Version: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Version : '',
        ComponentModel: cpus.ComponentModel || '',
        SerialNumber: cpus.SerialNumber || '',
        BusInfo: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].BusInfo : '',
        Capacity: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Capacity : 0,
        Clock: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Clock : 0,
        Size: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Size : 0,
        Slot: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Slot : '',
        Width: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Width : 0 || 0,
        Generation: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].Generation : '',
        ShortName: cpus && cpus['ProcessorComponents'] && cpus['ProcessorComponents'].length > 0 ? cpus['ProcessorComponents'][0].ShortName : '',
        Description: cpus.Description || ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            Version: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            BusInfo: Yup.string().required("Required"),
            Capacity: Yup.number().required("Required"),
            Clock: Yup.number().required("Required"),
            Size: Yup.number().required("Required"),
            Slot: Yup.string().required("Required"),
            Width: Yup.number().required("Required"),
            ShortName: Yup.string().required("Required"),
            Generation: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_cpu_component'] || "Edit cpu component",
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <CPUForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></CPUForm>
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        cpus: state.product.cpus.loaded ? state.product.cpus.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchCPUInit: cpus => dispatch(actions.loadCPUInit(cpus)),
        onFetchCPU: cpus => dispatch(actions.loadCPU(cpus)),
        onEditCPU: cpus => dispatch(actions.editCPU(cpus)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CPUEdit));
